import { defineNuxtPlugin } from '#app'
import { useHead } from '#imports'

export default defineNuxtPlugin(() => {
  useHead({
    script: [
      {
        src: '/scripts/api-engagement.js',
      },
    ],
  })
})
